// extracted by mini-css-extract-plugin
export default {"device":"index_device__nlfAP","box":"index_box__gsZRG"};